import { render, staticRenderFns } from "./course-repair.vue?vue&type=template&id=6d965966&scoped=true&"
import script from "./course-repair.vue?vue&type=script&lang=js&"
export * from "./course-repair.vue?vue&type=script&lang=js&"
import style0 from "./course-repair.vue?vue&type=style&index=0&id=6d965966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d965966",
  null
  
)

export default component.exports